import React, { useState } from 'react'
import { Hidden } from '@material-ui/core'

import Mobile from './Mobile'
import List from './List'

const hiddenForDesktopBreakpoints = {
  xs: { smUp: true },
  sm: { mdUp: true },
}

const hiddenForMobileBreakpoints = {
  xs: { xsDown: true },
  sm: { smDown: true },
}

export default ({ ListComponent = List, mobileStartsIn = 'xs', ...props }) => {
  const [open, setOpen] = useState(false)

  const handleClose = () => setOpen(false)
  const handleOpen = () => setOpen(true)

  return (
    <React.Fragment>
      <Hidden {...hiddenForMobileBreakpoints[mobileStartsIn]}>
        <ListComponent {...props} />
      </Hidden>
      <Hidden {...hiddenForDesktopBreakpoints[mobileStartsIn]}>
        <Mobile open={open} handleClose={handleClose} handleOpen={handleOpen}>
          <ListComponent {...props} onLinkClick={handleClose} />
        </Mobile>
      </Hidden>
    </React.Fragment>
  )
}
